import React from 'react';
import { Wifi, Sun, Moon, Menu, LogOut } from 'lucide-react';
import { useTheme } from '../../hooks/useTheme';
import { useAuth } from '../../contexts/AuthContext';

const Header = ({ onMenuToggle }) => {
  const { isDark, toggleTheme } = useTheme();
  const { user, logout } = useAuth();

  return (
    <div className="mb-8 flex items-start justify-between">
      <div className="flex items-center gap-3">
        <button onClick={onMenuToggle} className="lg:hidden p-2 hover:bg-elevated rounded-lg transition-colors text-txt-secondary" aria-label="Menu">
          <Menu size={22} />
        </button>
        <div>
          <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold bg-gradient-to-r from-blue-400 to-purple-500 bg-clip-text text-transparent mb-1 md:mb-2">
            Stock Monitor
          </h1>
          <p className="text-txt-secondary text-xs sm:text-sm md:text-base">Dati real-time da Finnhub - Mercati US & IT</p>
        </div>
      </div>
      <div className="flex items-center gap-2 sm:gap-3 text-xs">
        {user && (
          <div className="flex items-center gap-2">
            <span className="text-txt-secondary hidden sm:inline text-xs truncate max-w-[120px]">{user.email}</span>
            <button
              onClick={logout}
              className="p-2 hover:bg-red-500/10 rounded-lg transition-colors text-txt-secondary hover:text-red-500"
              aria-label="Logout"
              title="Logout"
            >
              <LogOut size={16} />
            </button>
          </div>
        )}
        <button onClick={toggleTheme} className="p-2 hover:bg-elevated rounded-lg transition-colors text-txt-secondary" aria-label="Cambia tema">
          {isDark ? <Sun size={18} /> : <Moon size={18} />}
        </button>
        <div className="flex items-center gap-1">
          <Wifi size={14} className="text-green-400" />
          <span className="text-green-400 hidden sm:inline">LIVE</span>
        </div>
      </div>
    </div>
  );
};

export default Header;
